var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2942 16.6169L18.0089 23.3333L31.6533 9.68889C28.8444 5.08444 23.7884 2 18 2C9.16267 2 2 9.16267 2 18C2 26.8373 9.16267 34 18 34C26.2347 34 33.0098 27.7778 33.8951 19.7778",
    stroke: "#9FBFE5",
    strokeOpacity: 0.996078,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCheck);
export default __webpack_public_path__ + "static/media/purchase-check.ff82932aa06713542ea8d0c4a25f54a2.svg";
export { ForwardRef as ReactComponent };